module.exports = __webpack_public_path__ + "img/banner-b.f897cd50.png";